import { TThdCustomerDefault } from '../models/b2c/account-profile';

const windowExists = () => typeof window !== 'undefined';

export const getTHDCustomer = (): TThdCustomerDefault => {
  const nullUser: TThdCustomerDefault = {
    customerType: '',
    isB2BCustomer: false,
    isB2XCustomer: false,
    isB2CCustomer: false,
    isLoggedIn: false,
    localizationStatus: 'default',
    isPersisted: false,
    isKMSI: false,
    role: null,
    segment: null,
    svocID: null,
    userID: null,
    token: null,
    jwt: null,
  };
  return windowExists() ? window?.THDCustomer?.default : nullUser;
};

export const getHostURL = (pathname: string): string => {
  let hostName = 'www.homedepot.com';
  if (windowExists()) {
    hostName = window?.THD_GLOBAL?.secureHostName || hostName;
  }
  return `https://${hostName}/${pathname}`;
};

export const getImageURL = (str: string) => {
  return `https://assets.thdstatic.com/images/v1/loyaltyBenefits/${str}`;
};

export const getTiersImageURL = (str: string) => {
  return getImageURL(`ProTiers/${str}`);
};

export const getPricingImageURL = (str: string) => {
  return getImageURL(`PricingBenefits/${str}`);
};

export const getB2bmyaccountFedURL = (str: string) => {
  // return getImageURL(`b2b/account/dist/${str}`); // won't work for localhost
  return `https://www.homedepot.com/b2b/account/dist/${str}`;
};
